var render = function render(){var _vm=this,_c=_vm._self._c;return _c('image-view',_vm._g(_vm._b({staticClass:"login-image-view"},'image-view',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"overlay"}),_c('div',{staticClass:"window"},[_c('div',{staticClass:"title"}),_c('div',{staticClass:"paragraph"}),_c('div',{staticClass:"input"}),_c('div',{staticClass:"input"}),_c('div',{staticClass:"btn"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }